import { FormValues, SelectedItems, Stage } from "../types/productTypes";

export default function createDefaultValues(
   stages: Stage[] | undefined
): Omit<FormValues, "details"> {
   if (!stages) {
      return {};
   }
   const defaults = stages.reduce<{ [key: string]: SelectedItems }>(
      (acc, stage) => {
         stage.options?.forEach((option) => {
            const fieldName = option.id?.toString();
            if (!fieldName) throw new Error("fieldName must be defined");
            console.log("default value", option.defaultValue);
            acc[fieldName] = {
               selectedItem:
                  option.defaultValue?.toString() ||
                  option.items
                     .find((item) => item.id || false)
                     ?.id?.toString() ||
                  "-1",
               selected: false,
            };
         });
         return acc;
      },
      {}
   );
   return defaults;
}
